<template>
  <div class="workspace-layout ion-padding">
    <main class="container">
      <welcome-message :name="user.FirstName" />

      <suite-app-section :title="t('home.yourApps')">
        <template v-if="false" #header-actions>
          <suite-input
            class="responsive-search"
            fa-icon="fa-magnifying-glass"
            :placeholder="t('common.search')" v-model="searchQuery"
            @focusin="() => showAppsHeaderButton = false"
            @focusout="() => showAppsHeaderButton = true"
          />
          <suite-button :hide="!showAppsHeaderButton && isMobileView()" fill="clear" class="show-all-btn">{{ t('common.showAll') }}</suite-button>
        </template>
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col
                v-for="service in filteredServices"
                :key="service.id"
                size="12"
                size-sm="6"
                size-md="4"
                size-lg="3"
            >
              <suite-app-card :service="service" :single-line="isMobileView()" />
            </ion-col>
          </ion-row>
        </ion-grid>
      </suite-app-section>

      <suite-app-section v-if="false && recentServices.length" :title="t('home.recentApps')">
        <div class="recent-apps-container">
          <suite-app-card
            v-for="recent in recentServices"
            :key="recent.id"
            @click="goTo(recent.url)"
            :service="recent" mini
          />
        </div>
      </suite-app-section>

      <activity-section />
    </main>
  </div>
  <ion-footer class="powered-by">
    <span>{{ t('home.poweredBy') }}</span>
    <ion-icon class="logo" :src="heilaLogo"></ion-icon>
  </ion-footer>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import {IonGrid, IonRow, IonCol, IonButton, IonIcon, isPlatform} from '@ionic/vue';
import { useNavigation } from '@/composables/useNavigation';
import SuiteAppSection from "@/components/suiteAppSection.vue";
import SuiteAppCard from "@/components/SuiteAppCard.vue";
import { useServices } from "@/composables/useServices.ts";
import { User } from '@/models/auth';
import SuiteInput from "@/components/SuiteInput.vue";
import {useSearch} from "@/composables/useSearch.ts";
import WelcomeMessage from "@/components/WelcomeMessage.vue";
import {useLocale} from "@/composables/useLocale.ts";
import heilaLogo from "../../assets/heila_logo.svg";
import ActivitySection from "@/components/ActivitySection.vue";
import SuiteButton from "@/components/SuiteButton.vue";
import {usePlatforms} from "@/composables/usePlatforms.ts";

const { goTo } = useNavigation();
const { t } = useLocale()
const { isMobileView } = usePlatforms();

const props = defineProps({
  user: {
    type: Object as () => User,
    required: true,
    default: () => ({})
  }
});

const showAppsHeaderButton = ref(true);

const user = computed(() => props.user);

const { services, recentServices } = useServices();

const { searchQuery, filteredItems: filteredServices } = useSearch(
    services,
    ["label", "description"]
);

</script>

<style scoped>
.workspace-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow-y: auto;
  background-color: #ffffff;
  font-family: system-ui, -apple-system, sans-serif;
}

.container {
  width: 100%;
  max-width: 1140px;
}

.recent-apps-container {
  display: flex;
  flex-wrap: wrap;
}

.show-all-btn {
  --color: var(--font-700);
  font-size: 0.9rem;
  font-weight: 500;
  text-transform: none;
  margin: 0;
}

.powered-by {
  position: sticky;
  background: #FBFBFB;
  width: 100vw;
  bottom: 0;
  border-top: 1px solid #a1a1a138;
  display: flex;
  justify-content: center;
  gap: 7px;
  color: #707070;
  align-items: center;
  font-size: .8rem;
  padding: .4rem .4rem calc(.4rem + env(safe-area-inset-bottom));
}

.responsive-search {
  --custom-width: 48px;
  --custom-focus-width: 200px;
}

.logo {
  font-size: 2rem;
}

@media (min-width: 768px) {
  .responsive-search {
    --custom-width: unset;
    --custom-focus-width: unset;
  }
}

</style>